import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import React from "react";
import { centered } from "../style";
export const IdVerification = () => {
    return (_jsx(Box, { sx: {
            height: "100vh",
            width: "100%",
            ...centered,
        }, children: _jsx(Box, { sx: {
                display: "flex",
                justifyContent: "end",
            }, children: _jsx(Box, { width: "50%" }) }) }));
};
